import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LengthLimiterDirective } from './length-limiter.directive';
import { FormsModule } from '@angular/forms';


@NgModule({
    declarations: [
        LengthLimiterDirective
    ],
    imports: [
        CommonModule,
        FormsModule,
    ],
    exports: [
        LengthLimiterDirective
    ]
})
export class LengthLimiterModule { }
